<div class="json-cv-container">
    <h2>JSON CV</h2>
    <app-json-editor [data]="data.json"></app-json-editor>
</div>
